const dec2hex = (dec: number): string => dec.toString(16).padStart(2, '0');

/**
 * Генерирует короткий DOM/CSS-безопасный случайный идентификатор (8 hex-символов),
 * так же как @cian/mf-registry генерирует instance.id.
 *
 * React useId здесь не подходит: независимые React-корни разных сервисов на одной
 * странице отдают одинаковые `:r0:`-идентификаторы и placeId'ы столкнутся.
 */
export const generateRandomString = (length = 8): string => {
  const randomArray = new Uint8Array(length / 2);

  if (globalThis.crypto?.getRandomValues) {
    globalThis.crypto.getRandomValues(randomArray);
  } else {
    randomArray.forEach((_, index) => {
      randomArray[index] = Math.floor(Math.random() * 256);
    });
  }

  return Array.from(randomArray, dec2hex).join('');
};
